import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ModalService } from "../../modal/modal.service";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { ModalCreateEditTaskModel } from "../../s25-task/modal.create.edit.task.component";

@TypeManagerDecorator("s25-ng-opt-create-todo-button")
@Component({
    selector: "s25-ng-opt-create-todo-button",
    template: ` <button class="btn btn-default" (click)="createTodo()">Create To Do Task</button> `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class S25OptCreateTodoButtonComponent {
    createTodo() {
        // TODO: add taskActionsCell ? or make it optional in the other type?
        ModalService.modal("create-edit-task", { taskType: 5, type: "create" } as ModalCreateEditTaskModel);
    }
}
